import React, { Component, setGlobal } from "reactn";
import { _ } from "js/vendor";
import styled from "styled-components";
import { FlexBox, ScrollBox } from "js/react/components/LayoutGrid";
import { ShowErrorDialog, ShowMessageDialog, ShowOfflineDialog, DialogContent } from "js/react/components/Dialogs/BaseDialog";
import {
    Divider,
    UIPane,
    UIPaneContents,
    UIPaneSideBar,
    UIPaneWithSideBar,
    WhiteIconButton
} from "js/react/components/UiComponents";
import Spinner from "js/react/components/Spinner";
import { Fragment } from "react";
import { FlexSpacer, Gap10, Gap20, Gap30 } from "js/react/components/Gap";
import { BEAUTIFUL_WORKSPACE_ACTION, PresentationFilters, SearchThrottleWait, WorkspaceAction } from "common/constants";
import { PresentationLibrarySideBar } from "js/editor/PresentationLibrary/PresentationLibrarySideBar";
import {
    PresentationLibraryController,
    PresentationLibraryDataService
} from "js/editor/PresentationLibrary/PresentationLibraryController";
import { getStaticUrl } from "js/config";
import { Button, Icon, DialogTitle, MenuItem, Select } from "@material-ui/core";
import { app } from "js/namespaces";
import { PresentationLibraryList } from "js/editor/PresentationLibrary/PresentationLibraryList";
import { PresentationLibraryGrid } from "js/editor/PresentationLibrary/PresentationLibraryGrid";
import { themeColors } from "js/react/sharedStyles";
import { UIController } from "js/editor/dialogs/UIController";
import { PresentationListHeader } from "js/editor/PresentationLibrary/PresentationListHeader";
import SortAlphabeticalVariant from "mdi-material-ui/SortAlphabeticalVariant";
import Update from "mdi-material-ui/Update";
import CalendarRange from "mdi-material-ui/CalendarRange";
import CloudSearch from "mdi-material-ui/CloudSearch";
import UpgradeButton from "js/react/components/UpgradeButton";
import EarnCreditButton from "js/react/components/EarnCreditButton";
import { FeatureType } from "common/features";
import { PresentationFilterContext } from "./PresentationFilterContext";
import { trackActivity, trackState } from "../../core/utilities/utilities";
import { ds } from "js/core/models/dataService";
import isConnected from "../../core/utilities/isConnected";
import ErrorHandler from "../../core/utilities/errorHandler";
import { BeautifulDialog } from "js/react/components/Dialogs/BaseDialog";
import { fullTextSearchApi } from "js/core/fullTextSearchApi";
import { appSearchNames } from "js/config";
import { NoMatchesFoundContainer } from "../../react/views/AddSlide/Panes/Components/NoMatchesFoundContainer";
import { TeamResourcesPane } from "js/editor/TeamResources/TeamResourcesPane";
import { TeamFoldersDataService } from "js/core/dataServices/TeamFoldersDataService";
import { HelpButton } from "../components/helpButton";
import getLocalStorage from "js/core/utilities/localStorage";
import { NoResourcesNotices } from "js/react/views/UserOptions/dialogs/NoResourcesNotices";
import { UserMenu } from "js/editor/components/UserMenu";
import getUserProfile from "js/core/services/userProfiles";

const localStorage = getLocalStorage();

const CloseButtonContainer = styled.div`
  text-align: right;
  margin-bottom: -15px;
  margin-top: 10px;
`;

const PresentationLibraryContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const LibraryHeaderContainer = styled.div`
  width: 100%;
  height: 50px;
  background: #333;
  padding: 0px;
  display: flex;
  align-items: center;
  color: white;

  .logo-desktop {
    height: 24px;
    cursor: pointer;
  }
  .logo-mobile {
    height: 20px;
    cursor: pointer;
  }
  .avatar{
     width: 30px;
     height: 30px;
  }
  input {
    color: white;
  }
  .MuiIcon-root {
    color: white;
  }
  .MuiSlider-rail {
    background: #aaa;
  } 
  .MuiSlider-track {
    background: #aaa;
  }
  
  .empty-trash-header {
    display: flex;
    align-items: center;
    height: 100%;
    .MuiIcon-root {
      color: orangered;
    }
    label {
        height: 100%;
        background: orangered;
        color: white;
        display: block;
        display: inline-flex;
        font-size: 14px;
        font-weight: 600;
        display: flex;
        align-items: center;
        padding: 0px 20px;
    }
  }
`;

const LogoBox = styled.div`
  background: #222;
  width: 260px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const EmptyFilterMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  & > div {
    padding: 30px;
    font-weight: 600;
    font-size: 24px;
    border: solid 1px orangered;
    color: #333;
    background: white;
    max-width: 700px;
    letter-spacing: 0px;
    text-align: center;
    div {
      font-size: 15px;
      font-weight: 500;
      margin-top: 10px;
      color: #555;
    }
  }
`;

const CreatePresentationButton = styled(Button)`
  flex-shrink: 0;
  .MuiButton-label{
    color: white;
  }
  .MuiIcon-root {
    background: ${themeColors.ui_blue};
    color: white;
    border-radius: 50%;
    padding: 3px;
    font-size: 17px;
  }
`;

const CreatePresentationButtonIntegrator = styled(CreatePresentationButton)`
    border: 1px solid ${themeColors.ui_blue} !important;
    padding: 0 !important;
    margin-right: 14px !important;

    .MuiButton-label{
        color: #444;
        background: transparent;
        padding: 10px 20px;
    }

    .dark-mode & {
        .MuiButton-label{
            color: #ccc;
        }
    }
`;

export const Breadcrumb = styled.div`
  font-size: 18px;
  text-transform: uppercase;
  margin-right: 10px;
  color: #444;
  flex-shrink: 0;

  .dark-mode & {
    color: #ccc;
  }
`;

const WarningBox = styled.div`
  background: ${themeColors.warning};
  color: white;
  font-size: 12px;
  font-weight: 600;
  padding: 10px 20px;
  text-transform: uppercase;
`;

const NotificationsLabelButton = styled(WhiteIconButton)`
    .MuiButtonBase-root {
        position: relative;
    }

    span.countLabel {
        position: absolute;
        color: white;
        background-color: ${themeColors.ui_blue};
        border-radius: 80px;
        min-width: 8px;
        height: 14px;
        font-weight: 600;
        top: 8px;
        left: 23px;
        padding: 1px 4px;
        letter-spacing: 0px;
        font-size: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.small {
            font-size: 9px;
            line-height: 15px;
        }
    }
`;

const IntegratorMessage = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
  color: white;
`;

class NotificationsLabel extends Component {
    constructor() {
        super();

        this.state = {
            unreadCount: 0
        };
    }

    setUnreadCount = () => {
        const workspaceId = UIController.getWorkspaceId();
        const unreadCount = app.notificationsService.unread.filter(notification => notification.event.workspaceId === workspaceId).length;
        this.setState({ unreadCount });
    }

    componentDidMount() {
        this.setUnreadCount();
        app.notificationsService.onUnreadChanged(this.setUnreadCount);
    }

    componentWillUnmount() {
        app.notificationsService.offUnreadChanged(this.setUnreadCount);
    }

    render() {
        const { onClick } = this.props;
        const { unreadCount } = this.state;

        return (
            <NotificationsLabelButton onClick={onClick}>
                <Icon>notifications</Icon>
                {unreadCount > 0 && <span className={`countLabel ${unreadCount > 99 ? "small" : ""}`}>{unreadCount > 999 ? ">1k" : unreadCount}</span>}
            </NotificationsLabelButton>
        );
    }
}

const IframeContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding-bottom: calc(56.25% + 40px);
`;

const StyledIframe = styled.iframe`
  position: absolute;
  width: 100%;
  height: 100%;
  border: solid 1px #333;
`;

const StyledDialogTitle = styled(DialogTitle)`
  text-align: right;
  padding: 5px !important;
  span {
    cursor: pointer;
  }
`;

class IntroToWorkspaceDialog extends Component {
    handleClose = () => {
        this.props.callback();
        this.props.closeDialog();
    }

    render() {
        return (
            <BeautifulDialog
                data-cy="intro-to-workspace-dialog"
                maxWidth="lg"
                onEscapeKeyDown={this.handleClose}
                onClose={this.handleClose}
            >
                <StyledDialogTitle>
                    <Icon onClick={this.handleClose}>
                        close
                    </Icon>
                </StyledDialogTitle>
                <DialogContent>
                    <IframeContainer>
                        <StyledIframe
                            allowFullScreen
                            src="https://www.beautiful.ai/embed/-MO3t5X1C-tKv-GW1KGf?utm_source=beautiful_player&utm_medium=embed&utm_campaign=-MNPpk-zS039hjt8SWVz"
                        />
                    </IframeContainer>
                </DialogContent>
            </BeautifulDialog>
        );
    }
}

export class PresentationLibrary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            type: "presentations",
            showSidebar: false,
            workspaceId: props.appState.attributes.presentations.workspaceId
        };

        if (props.defaultLocation) {
            this.state.type = props.defaultLocation.type;
        }
        this.ref = React.createRef();

        if (!this.state.workspaceId) {
            throw new Error("workspaceId must be present");
        }

        setGlobal({
            accountAvatarUrl: app.user.getAvatarUrl()
        });
    }

    handleClickLogo = () => {
        UIController.gotoMarketingPage();
    }

    handleCreateNewPresentation = event => {
        if (app.integrator) {
            // Open a new tab to the desktop presentation list
            window.open("/", "_blank");
        } else {
            //offline currently not supported as it just errors out when you try to create a presentation. Offline could fail at this point
            if (!isConnected.connected) {
                ShowOfflineDialog();
                return;
            }

            UIController.showCreatePresentationDialog(this.ref.current.state.filter)
                .catch(err => {
                    ErrorHandler.handleSlideLimitReached(err, { workspaceId: this.state.workspaceId });
                });
        }
    }

    handleShowNotifications = () => {
        UIController.showUserOptionsDialog("notifications");
    }

    handleShowUserOptions = () => {
        UIController.showUserOptionsDialog();
    }

    handleAppStateChanged = model => {
        // propagate backbone state into React
        this.setState({ workspaceId: model.attributes.presentations.workspaceId });
    }

    componentDidMount() {
        this.props.appState.on("change:presentations", this.handleAppStateChanged);

        // If there's gDriveFolderId specified, then we've been redirected from GDrive
        // so we need to create a new presentation in the specified folder
        const gDriveFolderId = new URL(window.location).searchParams.get("gDriveFolderId");
        if (gDriveFolderId) {
            this.handleCreateNewPresentation();
            return;
        }

        const workspaceAction = localStorage.getItem(BEAUTIFUL_WORKSPACE_ACTION);
        const isNewWorkspace =
            workspaceAction === WorkspaceAction.CREATED ||
            workspaceAction === WorkspaceAction.JOINED;

        if (isNewWorkspace) {
            localStorage.removeItem(BEAUTIFUL_WORKSPACE_ACTION);
            trackActivity("Organization", "Joined");
        }
    }

    componentWillUnmount() {
        this.props.appState.off("change:presentations", this.handleAppStateChanged);
    }

    handleContextMenu = event => {
        event.preventDefault();
    }

    handleClickEarnCredit() {
        UIController.showUserOptionsDialog("referrals");
    }

    handleSwitchType = type => {
        this.setState({ type });
        if (type === "team-resources") {
            trackActivity("Resources", "Viewed");
        }
    }

    render() {
        const { type, showSidebar, workspaceId } = this.state;
        const headerDesktop = (
            <LibraryHeaderContainer className="library-header">
                <LogoBox className="logo-box" onClick={this.handleClickLogo}>
                    <img className="logo-desktop" src={getStaticUrl("/images/beautifulai-logos/beautifulai-mark-reverse.svg")} />
                </LogoBox>

                <FlexBox fillWidth left>
                    <Gap30 />
                    {
                        type == "presentations" &&
                        <CreatePresentationButton
                            id="new-presentation-button" variant="text"
                            onClick={this.handleCreateNewPresentation}>
                            <Icon>add</Icon>Create New Presentation
                        </CreatePresentationButton>
                    }
                    <FlexSpacer />
                    <FlexBox fillHeight middle right style={{ paddingRight: 20 }}>
                        {workspaceId == "personal" && (
                            <EarnCreditButton onClick={this.handleClickEarnCredit} />
                        )}
                        <Gap20/>
                        {app.user.features.isFeatureEnabled(FeatureType.UPGRADE, workspaceId) && (
                            <UpgradeButton workspaceId={workspaceId} />
                        )}
                        <NotificationsLabel onClick={this.handleShowNotifications} />
                        <HelpButton />
                        <Gap10 />
                        <UserMenu canSwitchWorkspace />
                    </FlexBox>
                </FlexBox>
            </LibraryHeaderContainer>
        );
        const menuIcon = (showSidebar
            ? "navigate_before"
            : "menu"
        );
        const headerMobile = (
            <LibraryHeaderContainer className="library-header">
                <FlexBox
                    fillHeight
                    fillWidth
                    horizontalAlign="between"
                    style={{
                        paddingLeft: 20,
                        paddingRight: 20,
                    }}
                >
                    <FlexBox fillHeight middle onClick={() => {
                        this.setState({ showSidebar: !showSidebar });
                    }}>
                        <i className="micon">{menuIcon}</i>
                    </FlexBox>

                    {
                        !app.integrator &&
                        <LogoBox
                            className="logo-box"
                            onClick={this.handleClickLogo}
                        >
                            <img className="logo-mobile" src={getStaticUrl("/images/beautifulai-logos/beautifulai-logo-reverse.svg")} />
                        </LogoBox>
                    }
                    {
                        app.integrator &&
                        <IntegratorMessage>Select a presentation to embed or create a new one.</IntegratorMessage>
                    }

                    <UserMenu canSwitchWorkspace />
                </FlexBox>
            </LibraryHeaderContainer>
        );
        const header = app.isConstrained ? headerMobile : headerDesktop;
        return (
            <PresentationLibraryContainer onContextMenu={this.handleContextMenu}>
                {header}
                {type == "presentations" &&
                    <PresentationLibraryPane
                        ref={this.ref}
                        workspaceId={workspaceId}
                        collection={this.props.collection}
                        showWorkspaceChooser
                        onSwitchType={this.handleSwitchType}
                        appState={this.props.appState}
                        showSidebar={showSidebar}
                        createNewPresentation={this.handleCreateNewPresentation}
                        onHideSidebar={() => this.setState({ showSidebar: false })}
                    />
                }
                {type == "team-resources" &&
                    <TeamResourcesPane
                        defaultPane={this.props.defaultLocation?.pane}
                        onSwitchType={this.handleSwitchType}
                    />
                }

            </PresentationLibraryContainer>
        );
    }
}

export class LibraryTypeSelect extends Component {
    render() {
        let { libraryType, onSwitchType } = this.props;
        return (
            <Fragment>
                <Select id="libraryType" value={libraryType} onChange={event => onSwitchType(event.target.value)} disableUnderline>
                    <MenuItem value="presentations">My Presentations</MenuItem>
                    <MenuItem value="team-resources">Team Resources</MenuItem>
                </Select>
                <Divider/>
            </Fragment>
        );
    }
}

function getLibrarySettings() {
    return _.defaults(app.user.get("librarySettings"), {
        viewType: "grid",
        sortField: "modifiedAt",
        sortReverse: true,
        thumbnailSize: 300
    });
}

export class PresentationLibraryPane extends Component {
    constructor(props) {
        super(props);

        this.sideBarRef = React.createRef();
        this.scrollRef = React.createRef();

        const librarySettings = getLibrarySettings();

        this.fetchSearchResultsThrottled = _.throttle(this.fetchSearchResults, SearchThrottleWait, { leading: false });

        this.state = {
            hadFirstRender: false,
            presentations: [],
            draggedItems: [],
            userFolders: [],
            teamFolders: [],
            filter: {
                type: PresentationFilters.ALL_PRESENTATIONS
            },
            viewType: librarySettings.viewType,
            sort: {
                field: librarySettings.sortField,
                reverse: librarySettings.sortReverse
            },
            searchResults: null,
            prevWorkspaceId: props.workspaceId
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.workspaceId !== state.prevWorkspaceId) {
            return {
                ...state,
                prevWorkspaceId: props.workspaceId,
                filter: {
                    type: PresentationFilters.ALL_PRESENTATIONS
                },
            };
        } else {
            return state;
        }
    }

    onPresentationsChanged = presentations => {
        if (presentations.collection) {
            presentations = presentations.collection;
        }
        this.setState({ presentations });
    }

    onPresentationsUpdated = _.debounce(presentations => {
        if (!this.state.hadFirstRender) {
            const current = presentations.length;
            const total = Object.keys(presentations.references.attributes).length - 1;
            if (current != total) {
                this.setState({ isLoadingText: `${(current / total * 100).toFixed()}%` });
            }
        } else {
            this.onPresentationsChanged(presentations);
        }
    }, 50)

    onUserFoldersChanged = userFolders => {
        if (userFolders.collection) {
            userFolders = userFolders.collection;
        }
        this.setState({ userFolders });
    }

    componentDidMount() {
        this.presentationLibraryDS = new PresentationLibraryDataService({
            onPresentationsUpdated: this.onPresentationsUpdated,
            onPresentationsChanged: this.onPresentationsChanged,
            onUserFoldersChanged: this.onUserFoldersChanged,
            onTeamFoldersChanged: this.onTeamFoldersChanged
        });

        this.presentationLibraryDS.loadPresentationModels().then(() => {
            this.setState({ hadFirstRender: true, isLoadingText: "" });
        });

        this.teamFolderDS = new TeamFoldersDataService({
            onCollectionChanged: teamFolders => {
                this.setState({ teamFolders });
            }
        });

        const workspaceAction = localStorage.getItem(BEAUTIFUL_WORKSPACE_ACTION);

        this.isNewWorkspace =
            workspaceAction === WorkspaceAction.CREATED ||
            workspaceAction === WorkspaceAction.JOINED;
    }

    componentWillUnmount() {
        this.presentationLibraryDS.unsubscribe();
        this.teamFolderDS.unsubscribe();
    }

    saveUserSettings() {
        let { viewType, sort } = this.state;
        // do not persist the sort setting "relevance" - this is set in the UI when the user is searching only.
        if (sort.field !== "relevance") {
            app.user.update({
                librarySettings: { viewType, sortField: sort.field, sortReverse: sort.reverse }
            });
        }
    }

    get sortOptions() {
        const { search } = this.state;
        const options = [{
            value: "name", label: "Name", reverse: false, icon: <SortAlphabeticalVariant />
        }, {
            value: "createdAt", label: "Recently Created", reverse: true, icon: <CalendarRange />
        }, {
            value: "modifiedAt", label: "Recently Edited", reverse: true, icon: <Update />
        }];
        if (search) {
            options.push({
                value: "relevance", label: "Relevance", reverse: false, icon: <CloudSearch />
            });
        }
        return options;
    }

    handleSetViewType = viewType => {
        this.setState({ viewType });
        _.defer(() => this.saveUserSettings());
    }

    fetchSearchResults = async query => {
        if (!query || !query.length) {
            // if there was a query, the sort may have been set to "relevance"
            // here we revert back to the persisted setting
            const librarySettings = getLibrarySettings();
            const sort = {
                field: librarySettings.sortField,
                reverse: librarySettings.sortReverse
            };
            this.setState({ searchResults: null, sort });
            return;
        }

        const searchResults = await fullTextSearchApi(
            query,
            appSearchNames.slidesSearchEngine,
            [],
            null,
            {
                field: "presentation_id",
                size: 1
            });
        // when searching, initially we should set the sort to "relevance" but allow the user to override
        const sort = {
            field: "relevance",
            reverse: false
        };
        this.setState({ searchResults, sort });
    }

    handleSearch = search => {
        this.setState({ search });
        this.fetchSearchResultsThrottled(search);
    }

    handleSort = sort => {
        this.setState({ sort });
        _.defer(() => this.saveUserSettings());
    }

    handleSetFilter = filter => {
        this.setState({ filter: filter });
    }

    handleSelectedPresentation = async selection => {
        if (app.isConstrained) {
            await this.handleDoubleClickedPresentation(selection[0]);
        } else {
            this.props.onSelectedPresentation && this.props.onSelectedPresentation(selection[0]);
        }
    }

    handleDoubleClickedPresentation = async ({ id }) => {
        // take the id from this view's representation of a presentation and fetch backbone model with updated permissions
        const presentation = await ds.presentations.getPresentation(id, "write");
        if (presentation.get("softDeletedAt") != null) {
            return ShowErrorDialog({
                title: "Can't edit presentations in the trash",
                message: "Please restore this presentation back into your library before editing."
            });
        }
        if (!presentation.permissions.write || app.isConstrained) {
            PresentationLibraryController.playPresentation(presentation);
        } else {
            PresentationLibraryController.editPresentation(presentation, false);
        }
    }

    handleStartDragItems = selection => {
        this.setState({ draggedItems: selection });
    }

    handleDropDragItems = (selection, event) => {
        this.setState({ draggedItems: [] });
    }

    render() {
        const {
            workspaceId,
            appState,
            readOnly,
            onCloseDialog,
            showCloseIcon,
            showSidebar,
            createNewPresentation,
            onHideSidebar,
            onSwitchType,
        } = this.props;
        const { hadFirstRender, isLoadingText, thumbnailSize, viewType, userFolders, teamFolders, filter, draggedItems, sort } = this.state;

        if (!hadFirstRender) {
            return (<UIPane>
                <Spinner label={isLoadingText} />
            </UIPane>);
        }

        let breadcrumb;
        switch (filter.type) {
            case PresentationFilters.ALL_PRESENTATIONS:
                breadcrumb = "All Presentations";
                break;
            case PresentationFilters.OWNED_BY_ME:
                breadcrumb = "Owned by me";
                break;
            case PresentationFilters.SHARED_WITH_ME:
                breadcrumb = "Shared With Me";
                break;
            case PresentationFilters.FOLDER:
                breadcrumb = userFolders.find(f => f.id == filter.folderId).get("name");
                break;
            case PresentationFilters.TEAM_FOLDER:
                breadcrumb = ds.teams.find(t => t.id == filter.folderId)?.get("name");
                break;
            case PresentationFilters.TRASH:
                breadcrumb = "Trash";
                break;
        }

        let canEditLibraryItems = !app.integrator && app.user.features.isFeatureEnabled(FeatureType.EDIT_LIBRARY_ITEMS, appState.orgId) && !readOnly;

        return (
            <UIPaneWithSideBar>
                <UIPaneSideBar
                    show={showSidebar}
                    onHide={onHideSidebar}
                >
                    {
                        canEditLibraryItems &&
                        <LibraryTypeSelect libraryType="presentations" onSwitchType={onSwitchType}/>
                    }
                    <PresentationLibrarySideBar
                        workspaceId={workspaceId}
                        filter={filter}
                        onSetFilter={this.handleSetFilter}
                        userFolders={userFolders}
                        teamFolders={teamFolders}
                        readOnly={readOnly}
                        draggedItems={draggedItems}
                        canEditLibraryItems={canEditLibraryItems}
                    />
                </UIPaneSideBar>

                {
                    !app.isMobileOrTablet &&
                    <UIPaneContents style={{
                        paddingLeft: 30,
                        paddingRight: 10,
                        paddingBottom: 0
                    }}>
                        {
                            showCloseIcon &&
                            <CloseButtonContainer>
                                <Icon onClick={onCloseDialog}>
                                    close
                                </Icon>
                            </CloseButtonContainer>
                        }

                        <PresentationFilterContext.Provider value={filter}>
                            {
                                app.integrator &&
                                <>
                                    <Gap20 />
                                    <CreatePresentationButtonIntegrator
                                        id="new-presentation-button"
                                        variant="text"
                                        onClick={createNewPresentation}
                                    >
                                        <Icon>add</Icon>Create New Presentation
                                    </CreatePresentationButtonIntegrator>
                                </>
                            }
                            <FlexBox left middle style={{ height: 65 }}>
                                <Breadcrumb className="breadcrumb">{breadcrumb}</Breadcrumb>
                                {
                                    filter.type != PresentationFilters.TRASH &&
                                    <Fragment>
                                        <FlexSpacer />
                                        <PresentationListHeader
                                            onSearch={this.handleSearch}
                                            viewType={viewType}
                                            onSetViewType={this.handleSetViewType}
                                            sortOptions={this.sortOptions}
                                            onSetSort={this.handleSort}
                                            sort={sort}
                                            searchPlaceholder=""
                                        />
                                    </Fragment>
                                }
                                {
                                    filter.type == PresentationFilters.TRASH &&
                                    <FlexBox middle left fillWidth style={{ paddingRight: 40 }}>
                                        <WarningBox>WARNING : Items in your trash will be permanently deleted after 30
                                            days</WarningBox>
                                        <FlexSpacer />
                                        <Button onClick={PresentationLibraryController.emptyTrashNow}>
                                            <Icon>delete</Icon>Empty Trash Now
                                        </Button>
                                    </FlexBox>
                                }
                            </FlexBox>
                            <ScrollBox id="presentation_list" ref={this.scrollRef}
                                fillWidth
                                style={{ height: 0, flexGrow: 2, marginTop: 5, paddingRight: 10 }}
                            >
                                {this.renderItems()}
                            </ScrollBox>
                        </PresentationFilterContext.Provider>
                    </UIPaneContents>
                }
                {
                    app.isMobileOrTablet &&
                    <UIPaneContents>
                        {
                            showCloseIcon &&
                            <CloseButtonContainer>
                                <Icon onClick={onCloseDialog}>
                                    close
                                </Icon>
                            </CloseButtonContainer>
                        }

                        <PresentationFilterContext.Provider value={filter}>
                            <FlexBox center middle>
                                {
                                    filter.type != PresentationFilters.TRASH &&
                                    <Fragment>
                                        <PresentationListHeader
                                            onSearch={this.handleSearch}
                                            viewType={viewType}
                                            onSetViewType={this.handleSetViewType}
                                            sortOptions={this.sortOptions}
                                            onSetSort={this.handleSort}
                                            sort={sort}
                                            searchPlaceholder=""
                                        />
                                    </Fragment>
                                }
                                {
                                    filter.type == PresentationFilters.TRASH &&
                                    <FlexBox middle left fillWidth style={{ paddingRight: 40 }}>
                                        <WarningBox>WARNING : Items in your trash will be permamently deleted after 30
                                            days</WarningBox>
                                        <FlexSpacer />
                                        <Button onClick={PresentationLibraryController.emptyTrashNow}>
                                            <Icon>delete</Icon>Empty Trash Now
                                        </Button>
                                    </FlexBox>
                                }
                            </FlexBox>
                            <FlexBox middle style={{
                                margin: 20,
                                marginTop: 0,
                                marginBottom: 0,
                            }}>
                                <Breadcrumb className="breadcrumb" style={{
                                    width: "100%",
                                    marginRight: 0,
                                }}>{breadcrumb}</Breadcrumb>
                            </FlexBox>
                            <ScrollBox id="presentation_list" ref={this.scrollRef}
                                fillWidth
                                style={{ height: 0, flexGrow: 2, marginTop: 0, paddingRight: 10, paddingLeft: 10 }}
                            >
                                {this.renderItems()}
                                <Gap30/>
                            </ScrollBox>
                        </PresentationFilterContext.Provider>
                    </UIPaneContents>
                }
            </UIPaneWithSideBar>
        );
    }

    renderItems() {
        let { readOnly } = this.props;
        let { searchResults, search, sort, filter, viewType, presentations } = this.state;

        let items = PresentationLibraryController.getFilteredPresentations(presentations, {
            filter,
            searchResults,
            sort,
            isNewWorkspace: this.isNewWorkspace
        });

        if (items.length == 0) {
            let emptyMessage;
            switch (filter.type) {
                case PresentationFilters.ALL_PRESENTATIONS:
                case PresentationFilters.OWNED_BY_ME:
                    //currently readOnly is set to true when viewing presentation library from CopySlidePane.
                    if (readOnly || search) {
                        return <NoMatchesFoundContainer />;
                    } else {
                        emptyMessage = (
                            <div>
                                <h1>You have no presentations in this workspace.</h1>
                                {
                                    app.isConstrained
                                        ? <p>Open Beautiful.ai in your desktop browser to create one.</p>
                                        : <p>Click the Create Presentation button to create a new presentation.</p>
                                }
                            </div>
                        );
                    }
                    break;
                case PresentationFilters.SHARED_WITH_ME:
                    emptyMessage = (
                        <div>
                            <h1>No one has shared a presentation with you.</h1>
                            <p>Maybe you should share one of yours?</p>
                        </div>
                    );
                    break;
                case PresentationFilters.TRASH:
                    emptyMessage = (
                        <div>
                            <h1>You don't have any presentations in your trash.</h1>
                            <p>When you delete presentations, they'll stay here for 30 days before being deleted permanently (just in case you want to recover them)</p>
                        </div>
                    );
                    break;
                case PresentationFilters.FOLDER:
                    emptyMessage = (
                        <div>
                            <h1>This folder is empty.</h1>
                            {!app.isConstrained && <p>You can drag presentations into this folder to add them.</p>}
                        </div>
                    );
                    break;
                case PresentationFilters.TEAM_FOLDER:
                    emptyMessage = (
                        <div>
                            <h1>No one has added any presentations to this team folder yet.</h1>
                            <p>Maybe you could be the first? Just drag one of your presentations into this folder to share it with your team.</p>
                        </div>
                    );
                    break;
                default:
                    emptyMessage = <div><h1>No presentations found</h1></div>;
            }
            return <NoResourcesNotices>{emptyMessage}</NoResourcesNotices>;
        }

        if (viewType == "grid") {
            return (
                <PresentationLibraryGrid
                    items={items}
                    readOnly={readOnly}
                    onSelectedPresentation={this.handleSelectedPresentation}
                    onDoubleClick={this.handleDoubleClickedPresentation}
                    onStartDragItems={this.handleStartDragItems}
                    onDropDragItems={this.handleDropDragItems}
                />
            );
        } else {
            return (
                <PresentationLibraryList
                    items={items}
                    readOnly={readOnly}
                    sort={sort}
                    onSort={this.handleSort}
                    onSelectedPresentation={this.handleSelectedPresentation}
                    onDoubleClick={this.handleDoubleClickedPresentation}
                    onStartDragItems={this.handleStartDragItems}
                    onDropDragItems={this.handleDropDragItems}
                />
            );
        }
    }
}

